import { LyfeTooltip, Typography } from "@lyfegen-platform/react-common";
import { Theme } from "@material-ui/core";
import { FlexFormStatus, RefundStatus } from "../../../types/graphql-global-types";
import FlexTypographyComponent from "../../FlexTypographyComponent";
import { getRecordStatusCaseDetailsColorsAndIcons, TransactionStatus, transformTransactionStatusNames } from "../utils/status";
import { LiteBox } from "../../lite/LiteBox";
import OverflowTooltipTypography from "../../OverflowTooltipTypography";

interface RefundStatusProps {
	props: any;
	children: React.ReactNode;
	palette: Theme["palette"];
	t: any;
	text?: string;
}

interface SingleStatusTextProps {
	status: FlexFormStatus | RefundStatus | TransactionStatus.IN_REVIEW | TransactionStatus.ELIGIBLE;
	palette: Theme["palette"];
	t: any;
	textColor?: string;
	text?: string;
}

interface SingleStatusProps {
	status: FlexFormStatus | RefundStatus;
	palette: Theme["palette"];
	t: any;
	text?: string;
}

const Text: React.FC<SingleStatusTextProps> = ({ status, t, textColor, text }) => (
	<OverflowTooltipTypography type="status" style={{ marginLeft: "2px", color: textColor || "black" }}>
		{text || t(status)}
	</OverflowTooltipTypography>
);

const MultipleStatuses: React.FC<RefundStatusProps> = ({ props, palette, t, text }) => {
	const statuses = props.status;
	const [colors, icon] = getRecordStatusCaseDetailsColorsAndIcons(statuses[0], palette);
	const TooltipTitleStatus = () => {
		return (
			<LiteBox display="flex" maxWidth={"300px"} flexWrap="wrap" gap="2px">
				{statuses.map((status: FlexFormStatus | RefundStatus, index: number) => {
					if (index !== 0) {
						return <SingleStatus key={index} status={status} palette={palette} t={t} text={text} />;
					}
					return <></>;
				})}
			</LiteBox>
		);
	};

	return (
		<LiteBox display="flex">
			<LiteBox
				display="flex"
				alignItems="center"
				borderRadius="100px"
				backgroundColor={colors.light!}
				padding="3px 8px 3px 6px"
				maxWidth="fit-content"
			>
				<div style={{ lineHeight: "12px" }}>{icon}</div>
				<Text status={props.status[0]} palette={palette} t={t} textColor={colors.main} text={text} />
			</LiteBox>

			{props.status.length > 1 && (
				<LyfeTooltip placement="top" variant="light" title={<TooltipTitleStatus />}>
					<span style={{ marginLeft: "4px" }}>+{props.status.length - 1}</span>
				</LyfeTooltip>
			)}
		</LiteBox>
	);
};

const SingleStatus: React.FC<SingleStatusProps> = ({ status, palette, t, text }) => {
	const refundStatus = transformTransactionStatusNames(status);
	const [colors, icon] = getRecordStatusCaseDetailsColorsAndIcons(refundStatus, palette);

	return (
		<LiteBox
			display="flex"
			alignItems="center"
			height="22px"
			borderRadius="100px"
			backgroundColor={colors.light!}
			padding="3px 8px 3px 6px"
			maxWidth="fit-content"
		>
			<div style={{ lineHeight: "12px" }}>{icon}</div>
			<Text status={refundStatus} palette={palette} t={t} textColor={colors.main} text={text} />
		</LiteBox>
	);
};

const RefundStatusComponent: React.FC<RefundStatusProps> = ({ props, children, palette, t }) => {
	if (Array.isArray(props.status)) {
		return <MultipleStatuses props={props} palette={palette} t={t} children={children} text={props.text} />;
	}

	return <SingleStatus status={props.status} palette={palette} t={t} children={children} text={props.text} />;
};

export default RefundStatusComponent;
